var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"edit-div",attrs:{"id":'editDiv'+ _vm.module.widgets_id,"contenteditable":_vm.canEdit},domProps:{"innerHTML":_vm._s(_vm.innerText)},on:{"focus":function($event){_vm.isLocked = true},"blur":function($event){_vm.isLocked = false},"input":_vm.changeText}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ddae052","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/my_div_edit/index.vue
// module id = null
// module chunks = 